<div class="stepper">
  <div
    *ngFor="let step of steps"
    class="stepper__item-wrapper"
    [class.stepper__item-wrapper_active]="currentStep === step"
  >
    <div class="stepper__item-fill"></div>

    <svg class="stepper__item-bg">
      <use xlink:href="assets/img/wizard.svg#wizard-outline"></use>
    </svg>

    <div class="h3 stepper__item">
      {{ step }}
    </div>
  </div>
</div>
